module.exports = __webpack_public_path__ + "static/media/copy.ddb2ae44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/copy.svg
// module id = 463
// module chunks = 0